import { TiArrowSortedDown } from "react-icons/ti";

export function FilterButton({
  toggleDropdown,
  label,
  icon,
  className = "",
}) {
  const handleToggle = toggleDropdown ? () => toggleDropdown() : undefined;

  return (
    <button
      type="button"
      onClick={handleToggle}
      className={`
        inline-flex items-center gap-2
        px-4 py-2.5
        bg-white
        border border-gray-300
        rounded-lg
        text-gray-700 font-medium text-sm
        shadow-sm
        hover:bg-gray-50 hover:border-gray-400
        active:scale-[0.98]
        transition-all duration-150
        focus:outline-none focus:ring-2 focus:ring-blue-400
        ${className}
      `}
    >
      {/* Leading Icon */}
      {icon && (
        <span className="text-gray-400 flex items-center text-base">
          {icon}
        </span>
      )}

      {/* Label */}
      <span>{label}</span>

      {/* Down Arrow */}
      <TiArrowSortedDown className="text-gray-400 text-lg -mr-1" />
    </button>
  );
}
